<template>
  <div class="big-event box">
    <div class="container">

      <!-- 标题 -->
      <div class="home-title">
        <h1>大事件</h1>
        <h3>
          <a href="https://www.infoq.cn/profile/8E5635FB78E196/publish" target="_blank">查看更多></a>
        </h3>
      </div>

      <!-- 内容 -->
      <div class="event-content">
        <div class="event-content-top columns">
          <div class="main-cover column">
            <NewsColumn :data="events[0]" />
          </div>
          <div class="side-cover">
            <div class="left-cover column">
              <NewsColumn class="left-cover-top" :data="events[1]" :config="{ hasSummary: false }"/>
              <NewsColumn class="left-cover-bottom" :data="events[2]" :config="{ hasSummary: false }" />
            </div>
            <div class="right-cover column">
              <NewsColumn :data="events[5]" />
            </div>
          </div>
        </div>
        <div class="event-content-bottom columns is-multiline">
          <WordBoardColumn class="column is-half-tablet" :data="events[3]" />
          <WordBoardColumn class="column is-half-tablet" :data="events[6]" />
          <WordBoardColumn class="column is-half-tablet" :data="events[4]" />
          <WordBoardColumn class="column is-half-tablet" :data="events[7]" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NewsColumn from '@/components/columns/News'
import WordBoardColumn from '@/components/columns/WordBoard'

export default {
  props: ['events'],
  components: {
    NewsColumn,
    WordBoardColumn
  }
}
</script>

<style lang="scss" scoped>
@import '~@/style/variable.sass';
$gap: 16px;

// .column {
//   padding: $gap /2;
// }

.big-event {
  // padding-top: 40px;
  // background-color: #f5f5f5;
}
.home-title {
  margin-bottom: 20px;
}
.columns {
  margin: -10px -10px 0.75rem -10px;
}
.column {
  padding: 10px;
}

// 内容部分
.event-content {
  // overflow: hidden;
  .event-content-top {
    // display: flex; align-items: stretch;
    height: 262px;
    .main-cover {
      width: 50%;
    }
    .side-cover {
      width: 50%;
      display: flex;
      .left-cover {
        width: 40%;
        display: flex; flex-direction: column;

        & .left-cover-bottom {
          margin-top: 20px;
        }
      }
      .right-cover {
        width: 60%;
      }
    }
  }
  .event-content-bottom {
    position: relative;
    margin-top: -5px;
    &::before {
      position: absolute; top: 50%; left: 50%; transform: translateX(-50%) translateY(-50%);
      content: '';
      display: block;
      width: 1px; height: 184px;
      background: rgba(#091F2F, 0.05);
    }
    .column {}
  }
}

</style>
